import React from "react";

import css from "./PanelFooter.module.css";

export const PanelFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div className={css.main}>{children}</div>;
};
